var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { C as CarouselManager } from "./carouselManager.5a669b74.chunk.js";
import { f as fetchRetailRecommendations } from "./g-utils.f20531ac.chunk.js";
function slice(arrayLike, start, end) {
  return Array.prototype.slice.call(arrayLike, start, end);
}
function apply(func) {
  return func.bind(null, ...slice(arguments, 1));
}
function typeOf(type, subject) {
  return typeof subject === type;
}
apply(typeOf, "function");
apply(typeOf, "string");
apply(typeOf, "undefined");
document.addEventListener("search:pageFilterPriceClear", (e) => {
  pageFilterPriceClear();
});
function getcategoryFilter() {
  let categoryFilter;
  if (sessionStorage.getItem("categoryFilter")) {
    categoryFilter = JSON.parse(sessionStorage.getItem("categoryFilter"));
  }
  return categoryFilter;
}
function getSeriesFilterString() {
  let seriesFilterString;
  if (sessionStorage.getItem("seriesFilterString")) {
    seriesFilterString = JSON.parse(
      sessionStorage.getItem("seriesFilterString")
    );
  }
  return seriesFilterString;
}
function getFilterParse(query, categoryFilter, seriesFilterString, paramsQuery) {
  let queryString = "";
  if (paramsQuery) {
    queryString = paramsQuery.q;
  }
  let filterParse;
  if (sessionStorage.getItem("defaultFilters")) {
    filterParse = JSON.parse(sessionStorage.getItem("defaultFilters"));
    if (filterParse.queryString.length > 0) {
      if (categoryFilter) {
        filterParse.queryString.push(categoryFilter.categoryFilterString);
      }
      if (seriesFilterString) {
        filterParse.queryString.push(seriesFilterString.queryString);
      }
      if (queryString.includes("opusID")) {
        filterParse.queryString.push(
          `attributes.opus: ANY("${queryString.split(":")[1]}")`
        );
      }
      query.filterSearch = filterParse.queryString.join(" AND ");
    }
  } else {
    filterParse = { filterCheckedItems: [], queryString: [], filterPrice: {} };
    if (categoryFilter) {
      filterParse.queryString.push(categoryFilter.categoryFilterString);
    }
    if (seriesFilterString) {
      filterParse.queryString.push(seriesFilterString.queryString);
    }
    if (queryString.includes("opusID")) {
      filterParse.queryString.push(
        `attributes.opus: ANY("${queryString.split(":")[1]}")`
      );
    }
    query.filterSearch = filterParse.queryString.join(" AND ");
  }
  return filterParse;
}
document.addEventListener("search:resetsessionStorageVariablesFilters", (e) => {
  sessionStorage.setItem("defaultFilters", "");
  sessionStorage.setItem("productsPerPage", "");
  sessionStorage.setItem("currentPage", "");
  sessionStorage.setItem("sortPageMode", "");
  sessionStorage.setItem("categoryFilter", "");
  sessionStorage.setItem("seriesFilterString", "");
});
if (!sessionStorage.getItem("enterTime")) {
  sessionStorage.setItem("enterTime", /* @__PURE__ */ new Date());
}
const enterTime = sessionStorage.getItem("enterTime");
document.addEventListener("click", async (e) => {
  const clickedEl = e.target.closest(".js-facet-redirect");
  if (clickedEl) {
    e.preventDefault();
    const redirectKey = clickedEl.dataset.facetKey;
    const redirectValue = clickedEl.dataset.facetValue;
    let nextURL = window.location.origin;
    if (redirectKey == "author") {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "click_autocomplete_ta",
        search_query: redirectValue,
        autocomplete_type: redirectKey
      });
    }
    if (redirectKey == "opus") {
      const redirectOpus = clickedEl.dataset.facetOpus;
      nextURL = nextURL + `/products/${redirectOpus}`;
    } else {
      nextURL = nextURL + `/pages/search?q=${encodeURIComponent(redirectValue)}`;
    }
    sessionStorage.setItem("redirectKey", redirectKey);
    window.location.href = nextURL;
  }
});
const container = document.querySelector("[data-filters]");
const getUniqueValues = (arr) => [...new Set(arr)];
const facetToRender = [
  {
    facet_title: "Categories",
    facet_key: "categories",
    show_search: true,
    autocomplete_key: "category"
  },
  {
    facet_title: "Prix",
    facet_key: "price",
    show_search: false,
    autocomplete_key: ""
  },
  {
    facet_title: "Auteur",
    facet_key: "brands",
    show_search: true,
    autocomplete_key: "author"
  },
  {
    facet_title: "Format",
    facet_key: "attributes.format",
    show_search: false,
    autocomplete_key: ""
  },
  {
    facet_title: "Éditeur",
    facet_key: "attributes.publisher",
    show_search: true,
    autocomplete_key: "publisher"
  },
  {
    facet_title: "Date de parution",
    facet_key: "attributes.publicationDate",
    show_search: false,
    autocomplete_key: ""
  },
  {
    facet_title: "Langue",
    facet_key: "attributes.language",
    show_search: true,
    autocomplete_key: ""
  },
  {
    facet_title: "Produits en stock uniquement",
    facet_key: "availability",
    show_search: false,
    autocomplete_key: ""
  }
];
const languageAssosiation = {
  "ar": "Arabic",
  "ca-ES": "Catalan",
  "da-DK": "Danish",
  "de-DE": "Allemand",
  "en-US": "Anglais",
  "es-ES": "Espagnol",
  "fr-FR": "Français",
  "hr-HR": "Croate",
  "it-IT": "Italienne",
  "ja-JP": "Japonais",
  "ko-KR": "Coréen",
  "nl-NL": "Néerlandais",
  "pl-PL": "Polonaise",
  "pt-BR": "Portuguese",
  "ro-RO": "Romanian",
  "ru-RU": "Russian",
  "sv-SE": "Swedish",
  "zh-CN": "Chinese",
  "tr-TR": "Turc"
};
const dateAssosiation = {
  "Moins de 2 ans": Math.round(new Date(new Date(enterTime).setFullYear(new Date(enterTime).getFullYear() - 2)).getTime() / 1e3) + "-M",
  "Moins de 5 ans": Math.round(new Date(new Date(enterTime).setFullYear(new Date(enterTime).getFullYear() - 5)).getTime() / 1e3) + "-M",
  "Moins de 10 ans": Math.round(new Date(new Date(enterTime).setFullYear(new Date(enterTime).getFullYear() - 10)).getTime() / 1e3) + "-M",
  "Plus de 10 ans": Math.round(new Date(new Date(enterTime).setFullYear(new Date(enterTime).getFullYear() - 10)).getTime() / 1e3) + "-P"
};
const availabilityAssosiation = {
  "IN_STOCK": "En stock"
};
async function updateFilters(url, filterParse, query, data) {
  if (data.results) {
    updateRenderedFilters(data, filterParse);
  }
}
async function getFilters(event, url, filterParse, paramsQuery, paramsQuerySearchText, data) {
  if (data.results) {
    renderFilters(data, filterParse);
    renderOpusHeader(paramsQuery, event, data);
  }
}
function renderFilters(data, filterParse) {
  var _a, _b;
  const filterActivePriceMin = (_a = filterParse == null ? void 0 : filterParse.filterPrice) == null ? void 0 : _a.min;
  const filterActivePriceMax = (_b = filterParse == null ? void 0 : filterParse.filterPrice) == null ? void 0 : _b.max;
  const activeFiltersItems = (filterParse == null ? void 0 : filterParse.filterCheckedItems) ?? [];
  const filterPriceMax = data.facets.find((facet) => facet.key == "price").values[0].maxValue;
  let clickedFilter = window.lastCheckedFilter || "";
  if (clickedFilter != "") {
    clickedFilter = clickedFilter.closest("filter-block").id;
    let numberOfSelectedFilters = document.getElementById(clickedFilter).querySelectorAll("filter-item [name^='filter.p']:checked");
    if (numberOfSelectedFilters.length == 0) {
      clickedFilter = "";
    }
  }
  if (document.querySelectorAll("filter-block").length > 1) {
    document.querySelectorAll("filter-block").forEach((filterBlock) => {
      for (const facet in facetToRender) {
        if (facetToRender[facet].facet_key != "price" && facetToRender[facet].facet_key != "categories" && facetToRender[facet].facet_key != "attributes.publicationDate" && facetToRender[facet].facet_key != "availability" && facetToRender[facet].facet_key != clickedFilter) {
          if (facetToRender[facet].facet_key == filterBlock.id) {
            filterBlock.setChildItemFilter = {
              data: data.facets.find((initial_facet) => initial_facet.key == facetToRender[facet].facet_key).values || [],
              type: facetToRender[facet].facet_key,
              checkedItems: activeFiltersItems
            };
          }
        }
      }
    });
  } else {
    for (const facet in facetToRender) {
      if (facetToRender[facet].facet_key == "availability") {
        continue;
      }
      const filterBlock = document.createElement("filter-block");
      filterBlock.setParentBlockFilterText = {
        title: facetToRender[facet].facet_title,
        type: facetToRender[facet].facet_key,
        showSearch: facetToRender[facet].show_search
      };
      if (facetToRender[facet].facet_key != "price" && facetToRender[facet].facet_key != "categories" && facetToRender[facet].facet_key != "availability" && facetToRender[facet].facet_key != "attributes.publicationDate") {
        filterBlock.setChildItemFilter = {
          data: data.facets.find((initial_facet) => initial_facet.key == facetToRender[facet].facet_key).values || [],
          type: facetToRender[facet].facet_key,
          checkedItems: activeFiltersItems
        };
      }
      if (facetToRender[facet].facet_key == "categories") {
        filterBlock.setChildItemCategory = {
          title: facetToRender[facet].facet_title,
          type: facetToRender[facet].facet_key,
          data: data.facets.find((initial_facet) => initial_facet.key == facetToRender[facet].facet_key).values || []
        };
      }
      if (facetToRender[facet].facet_key == "price") {
        filterBlock.setChildItemPrice = {
          title: facetToRender[facet].facet_title,
          type: facetToRender[facet].facet_key,
          data: data.facets.find((initial_facet) => initial_facet.key == facetToRender[facet].facet_key).values || [],
          priceMax: Math.ceil(filterPriceMax),
          priceActiveMin: filterActivePriceMin,
          priceActiveMax: filterActivePriceMax
        };
      }
      if (facetToRender[facet].facet_key == "attributes.publicationDate") {
        filterBlock.setChildItemDate = {
          title: facetToRender[facet].facet_title,
          type: facetToRender[facet].facet_key,
          data: dateAssosiation || [],
          checkedItems: activeFiltersItems
        };
      }
      filterBlock.setAttribute("id", facetToRender[facet].facet_key);
      container.appendChild(filterBlock);
    }
  }
}
function updateRenderedFilters(data, filterParse) {
  let notInListFilters = (filterParse == null ? void 0 : filterParse.filterCheckedItems) || [];
  notInListFilters.map((unlistedFilter) => {
    const filterToCheck = document.querySelector(`input[id="${unlistedFilter}"]`);
    if (!filterToCheck) {
      let filterValue = unlistedFilter.split("-")[1];
      let filterType = unlistedFilter.split("-")[0].split("filter.p.")[1];
      const filterItem = document.createElement("filter-item");
      filterItem.className = "collection__filter-checkbox";
      filterItem.filters = {
        checked: true,
        type: filterType,
        value: filterValue
      };
      document.querySelector(`filter-block[id='${filterType}'] .collection__filter-checkbox-list`).appendChild(filterItem);
    }
  });
  const activeFiltersItems = (filterParse == null ? void 0 : filterParse.filterCheckedItems) ?? [];
  let clickedFilter = window.lastCheckedFilter || "";
  if (clickedFilter != "") {
    clickedFilter = clickedFilter.closest("filter-block").id;
    let numberOfSelectedFilters = document.getElementById(clickedFilter).querySelectorAll("filter-item [name^='filter.p']:checked");
    if (numberOfSelectedFilters.length == 0) {
      clickedFilter = "";
    }
  }
  if (document.querySelector("filter-block")) {
    document.querySelectorAll("filter-block").forEach((filterBlock) => {
      var _a;
      for (const facet in facetToRender) {
        if (facetToRender[facet].facet_key != "price" && facetToRender[facet].facet_key != "attributes.publicationDate" && facetToRender[facet].facet_key != "availability" && facetToRender[facet].facet_key != clickedFilter) {
          if (facetToRender[facet].facet_key == filterBlock.id) {
            filterBlock.updateChildItemFilter = {
              data: ((_a = data.facets.find((initial_facet) => initial_facet.key == facetToRender[facet].facet_key)) == null ? void 0 : _a.values) || [],
              type: facetToRender[facet].facet_key,
              checkedItems: activeFiltersItems
            };
          }
        }
      }
    });
  }
}
async function renderOpusHeader(paramsQuery, event, data) {
  const productsResults = data.results;
  let searchProductVariants = [];
  productsResults.forEach((searchProduct) => {
    searchProductVariants.push(searchProduct.product);
  });
  const authorsFiler = data.facets.find((facet) => facet.key == "brands").values || [];
  const faceSaga = data.facets.find((facet) => facet.key == "attributes.series");
  if (paramsQuery.q.includes("opusID")) {
    const facetSagaName = faceSaga.values ? faceSaga.values[0].value : "";
    const templateBlockOpusHeader = document.getElementById("opus_header_template");
    const opusHeaderTemplate = templateBlockOpusHeader.innerHTML.replaceAll("[title]", searchProductVariants[0].title).replaceAll("[author]", authorsFiler[0].value).replaceAll("[sagaName]", facetSagaName ?? "");
    document.title = document.title.split(" - ").map((el) => {
      if (el.indexOf("opusID:") > -1) {
        return searchProductVariants[0].title;
      } else {
        return el;
      }
    }).join(" - ");
    event.element.querySelector("[data-opus-header]").innerHTML = opusHeaderTemplate;
    if (event.element.querySelector("[data-breadcrumb-opus]")) {
      event.element.querySelector("[data-breadcrumb-opus]").innerHTML = event.element.querySelector("[data-breadcrumb-opus]").innerHTML = `"${searchProductVariants[0].title}"`;
    }
    document.querySelector(".jc-search-header").classList.add("jc-hidden");
    document.querySelector(".jc-opus-header").classList.remove("jc-hidden");
    if (!faceSaga.values) {
      event.element.querySelector("opus-series").closest(".splide__slide").classList.add("!jc-hidden");
    }
    if (!authorsFiler.values) {
      event.element.querySelector("opus-author").closest(".splide__slide").classList.add("!jc-hidden");
    }
    const opusInfosSliderEl = document.querySelector("#opus-infos-slider");
    await CarouselManager.create(opusInfosSliderEl, {
      arrows: false,
      pagination: false,
      perPage: 2,
      gap: 8,
      breakpoints: {
        640: {
          perPage: 1.15,
          destroy: true
        }
      }
    });
  }
}
class FilterBlock extends HTMLElement {
  constructor() {
    super();
  }
  // Use properties to dynamically update the content
  set setParentBlockFilterText(filterData) {
    this.innerHTML = document.getElementById("filter-collapsible-block").innerHTML;
    this.classList.add("[&_.collection-filter-group]:last:!jc-pb-0");
    this.querySelector(".filter-collapsible-block-title").textContent = filterData.title;
    this.querySelector("input").placeholder = filterData.title;
    this.querySelector(".collection__filter-group-name").setAttribute("aria-controls", `filter-p-${filterData.type.replaceAll(".", "_")}`);
    this.querySelector(".collection__filter-collapsible").id = `filter-p-${filterData.type.replaceAll(".", "_")}`;
    if (filterData.showSearch == false) {
      this.querySelector("search-filter-block").remove();
    }
    if (filterData.type == "availability") {
      this.querySelector("button").classList.add("jc-hidden");
    }
  }
  set setChildItemFilter(filterData) {
    const checkedFilters = filterData.checkedItems.map((checkedItem) => checkedItem.split(/-(.*)/s)[1]);
    filterData.data.map((facet) => {
      let existedFilter = "";
      const escapedValue = facet.value.replace(/([\'\"\\.])/g, "\\$1");
      existedFilter = this.querySelector(`[id='filter\\.p\\.${filterData.type}-${escapedValue}']`);
      if (!existedFilter) {
        const filterItem = document.createElement("filter-item");
        filterItem.className = "collection__filter-checkbox";
        filterItem.filters = {
          checked: checkedFilters.includes(facet.value),
          type: filterData.type,
          value: facet.value
        };
        this.querySelector(".collection__filter-checkbox-list").appendChild(filterItem);
      }
    });
  }
  set setChildItemFilterAvailability(filterData) {
    const checkedFilters = filterData.checkedItems.map((checkedItem) => checkedItem.split(/-(.*)/s)[1]);
    filterData.data.map((facet) => {
      const filterItem = document.createElement("filter-item");
      filterItem.className = "collection__filter-checkbox";
      filterItem.filters = {
        checked: checkedFilters.includes(facet.value),
        type: filterData.type,
        value: facet.value,
        title: filterData.title
      };
      this.querySelector(".collection__filter-checkbox-list").appendChild(filterItem);
    });
  }
  set updateChildItemFilter(filterData) {
    const checkedFilters = document.querySelectorAll("filter-item [name^='filter.p']:checked");
    const checkedFiltersBlocks = Array.from(checkedFilters).map((el) => el.closest("filter-block").id);
    const numberOfBlockWithCheckedFilters = getUniqueValues(checkedFiltersBlocks);
    if (sessionStorage.getItem("categoryFilter") != "") {
      numberOfBlockWithCheckedFilters.push("categories");
    }
    if (this.id == filterData.type) {
      if (this.id == "categories") {
        this.querySelectorAll("[data-parent-category] > *").forEach((el) => {
          if (el.closest("filter-block").id != "attributes.publicationDate") {
            el.classList.add("jc-hidden", "jc-pointer-events-none");
          }
        });
      } else {
        this.querySelectorAll("filter-item").forEach((el) => {
          if (el.closest("filter-block").id != "attributes.publicationDate") {
            el.classList.add("jc-hidden", "jc-pointer-events-none");
          }
        });
      }
    }
    filterData.data.map((facet) => {
      if (filterData.type == "categories") {
        const category = facet.value.split(" > ");
        const categoryName = category[0];
        const categorySubName = category[1] || "";
        const categoryBlock = this.querySelector(`[data-parent-category="${categoryName}"] p`);
        if (categoryBlock) {
          categoryBlock.classList.remove("jc-hidden", "jc-pointer-events-none");
          if (categorySubName) {
            const subCategoryBlock = categoryBlock.closest("[data-parent-category]").querySelector(`[data-sub-category="${categorySubName}"]`);
            if (subCategoryBlock) {
              subCategoryBlock.classList.remove("jc-hidden", "jc-pointer-events-none");
            }
          }
        }
      } else {
        const escapedValue = facet.value.replace(/([\'\"\\.])/g, "\\$1");
        const existedFilter = this.querySelector(`[id='filter\\.p\\.${filterData.type}-${escapedValue}']`);
        if (existedFilter) {
          existedFilter.closest("filter-item").classList.remove("jc-hidden", "jc-pointer-events-none");
        }
      }
    });
    if (numberOfBlockWithCheckedFilters.length == 1 && numberOfBlockWithCheckedFilters[0] == this.id) {
      this.querySelectorAll(".jc-hidden.jc-pointer-events-none").forEach((el) => {
        if (this.id != "attributes.publicationDate") {
          el.classList.remove("jc-hidden", "jc-pointer-events-none");
        }
      });
    }
  }
  set setChildItemPrice(priceData) {
    this.querySelector(".collection__filter-checkbox-list").innerHTML = "";
    const filterItem = document.createElement("filter-price-item");
    filterItem.filters = priceData;
    this.querySelector(".collection__filter-checkbox-list").appendChild(filterItem);
  }
  set setChildItemCategory(categoryData) {
    this.querySelector(".collection__filter-checkbox-list").innerHTML = "";
    const filterItem = document.createElement("filter-category-item");
    filterItem.filters = categoryData;
    this.querySelector(".collection__filter-checkbox-list").appendChild(filterItem);
  }
  set setChildItemDate(dateData) {
    const checkedFilters = dateData.checkedItems.map((checkedItem) => checkedItem.split(/-(.*)/s)[1]);
    for (const [facet, value] of Object.entries(dateData.data)) {
      const filterItem = document.createElement("filter-item");
      filterItem.className = "collection__filter-checkbox";
      filterItem.filters = {
        checked: checkedFilters.includes(dateAssosiation[facet]),
        type: dateData.type,
        value: dateAssosiation[facet],
        facetValue: facet
      };
      this.querySelector(".collection__filter-checkbox-list").appendChild(filterItem);
      if (dateData.data[Object.keys(dateData.data)[Object.keys(dateData.data).length - 1]] == value) {
        filterItem.updatePublicationDate();
      }
    }
  }
}
class FilterItem extends HTMLElement {
  constructor() {
    super();
  }
  updatePublicationDate() {
    this.closest("filter-block").querySelectorAll("filter-item").forEach((el) => {
      el.classList.remove("jc-hidden", "jc-pointer-events-none");
    });
    const activeFilterDate = this.closest("filter-block").querySelector("input:checked");
    if (activeFilterDate) {
      const uncheckedDate = this.closest("filter-block").querySelectorAll(`label:not([for*="${activeFilterDate.id.split("-").pop()}"])`);
      uncheckedDate.forEach((date) => {
        date.closest("filter-item").classList.add("jc-hidden", "jc-pointer-events-none");
      });
    }
  }
  // Use properties to dynamically update the content
  set filters(filterData) {
    const filterType = filterData.type;
    const filterValue = filterData.value;
    if (filterType == "attributes.publicationDate") {
      this.addEventListener("click", this.updatePublicationDate);
    }
    if (filterType == "availability") {
      this.innerHTML = document.getElementById("filter-collapsible-block-item-availability").innerHTML;
      this.querySelector("label").click();
    } else {
      this.innerHTML = document.getElementById("filter-collapsible-block-item").innerHTML;
    }
    if (filterType == "availability") {
      this.querySelector("p").textContent = filterData.title;
    } else {
      this.querySelector("label").textContent = (() => {
        switch (filterData.type) {
          case "attributes.language":
            return languageAssosiation[filterValue];
          case "availability":
            return availabilityAssosiation[filterValue];
          case "attributes.publicationDate":
            return filterData.facetValue;
          default:
            return filterValue;
        }
      })();
    }
    this.querySelector("input").value = filterValue;
    this.querySelector("input").id = `filter.p.${filterType}-${filterValue}`;
    this.querySelector("input").setAttribute("name", `filter.p.${filterType}`);
    if (filterData.checked) {
      this.querySelector("input").checked = true;
    }
    this.querySelector("label").setAttribute("for", `filter.p.${filterType}-${filterValue}`);
  }
}
class FilterPriceItem extends HTMLElement {
  constructor() {
    super();
  }
  // Use properties to dynamically update the content
  set filters(priceData) {
    this.innerHTML = document.getElementById("filter-collapsible-price-block-item").innerHTML;
    let maxValue = priceData.priceMax;
    let currentMinValue = priceData.priceActiveMin;
    let currentMaxValue = priceData.priceActiveMax;
    let range_min = currentMinValue ? currentMinValue / maxValue * 100 + " %" : 0 / maxValue * 100 + "%";
    let range_max = currentMaxValue ? currentMaxValue / maxValue * 100 + "%" : maxValue / maxValue * 100 + "%";
    let range_min_val = currentMinValue ? currentMinValue : "0";
    let range_max_val = currentMaxValue ? currentMaxValue : maxValue;
    let currentMin = currentMinValue ? currentMinValue : "";
    let currentMax = currentMaxValue ? currentMaxValue : "";
    this.querySelector(".price-range__range-group").setAttribute("style", `--range-min:${range_min};--range-max:${range_max}`);
    this.querySelector(".range-min").setAttribute("max", maxValue);
    this.querySelector(".range-min").setAttribute("value", range_min_val);
    this.querySelector(".range-max").setAttribute("max", maxValue);
    this.querySelector(".range-max").setAttribute("value", range_max_val);
    this.querySelector("[name=filter\\.v\\.price\\.gte]").setAttribute("max", maxValue);
    if (currentMin) {
      this.querySelector("[name=filter\\.v\\.price\\.gte]").setAttribute("value", currentMin);
    } else {
      this.querySelector("[name=filter\\.v\\.price\\.gte]").setAttribute("value", 0);
    }
    this.querySelector("[name=filter\\.v\\.price\\.lte]").setAttribute("max", maxValue);
    if (currentMax) {
      this.querySelector("[name=filter\\.v\\.price\\.lte]").setAttribute("value", currentMax);
    } else {
      this.querySelector("[name=filter\\.v\\.price\\.lte]").setAttribute("value", maxValue);
    }
  }
}
class FilterCategoryItem extends HTMLElement {
  constructor() {
    super();
  }
  // Use properties to dynamically update the content
  set filters(categoryData) {
    const arrayFilteredCategories = this.parseCategoryData(categoryData);
    arrayFilteredCategories.forEach((category) => {
      let parentCategoryBlock = document.querySelector(`[data-parent-category='${category.categoryName}']`);
      let categoryBlock = "";
      if (!parentCategoryBlock) {
        categoryBlock = document.createElement("ul");
        categoryBlock.className = "jc-list-none";
        categoryBlock.setAttribute("data-parent-category", category.categoryName);
        const categoryBlockTitle = document.createElement("p");
        categoryBlockTitle.className = "jc-m-0 jc-py-1.5 jc-text-sm jc-leading-5 jc-font-semibold jc-cursor-pointer jc-text-richBlack";
        categoryBlockTitle.textContent = category.categoryName;
        categoryBlock.appendChild(categoryBlockTitle);
      } else {
        categoryBlock = parentCategoryBlock;
      }
      if (category.subCategoryArray) {
        category.subCategoryArray.filter((el) => el).forEach((subcategory) => {
          let subcategoryBlock = "";
          if (subcategory.subCategoryName.indexOf('"') > -1) {
            subcategoryBlock = categoryBlock.querySelector(`[data-sub-category='${subcategory.subCategoryName}']`);
          } else if (subcategory.subCategoryName.indexOf("'") > -1) {
            subcategoryBlock = categoryBlock.querySelector(`[data-sub-category="${subcategory.subCategoryName}"]`);
          } else {
            subcategoryBlock = categoryBlock.querySelector(`[data-sub-category="${subcategory.subCategoryName}"]`);
          }
          if (!subcategoryBlock) {
            const subCategoryBlock = document.createElement("li");
            subCategoryBlock.setAttribute("data-sub-category", subcategory.subCategoryName);
            subCategoryBlock.className = "jc-px-3 jc-py-1.5 jc-text-sm jc-leading-5 jc-cursor-pointer js-filter-category jc-transition-colors jc-duration-300 hover:jc-text-independence focus:jc-text-electricViolet active:jc-text-electricViolet";
            subCategoryBlock.textContent = subcategory.subCategoryName;
            categoryBlock.appendChild(subCategoryBlock);
          }
        });
      }
      categoryBlock.addEventListener("click", (e) => {
        if (e.target.tagName == "LI" || e.target.tagName == "P") {
          const categoryFilter = {
            categoryFilterString: "",
            categoryFilterActive: []
          };
          if (e.target.tagName == "LI") {
            const categoryName = e.target.parentNode.dataset.parentCategory;
            const categorySubName = e.target.dataset.subCategory;
            categoryFilter.categoryFilterString = `categories: ANY("${categoryName} > ${categorySubName}")`;
            categoryFilter.categoryFilterActive.push(`${categoryName} > ${categorySubName}`);
          } else if (e.target.tagName == "P") {
            const categoryName = e.target.parentNode.dataset.parentCategory;
            const categorySubNames = Array.from(e.target.parentNode.querySelectorAll("li"));
            if (categorySubNames.length > 0) {
              const categoriesFilterString = categorySubNames.map((categorySub) => {
                return `"${categoryName} > ${categorySub.dataset.subCategory}"`;
              }).join(",");
              categoryFilter.categoryFilterString = `categories: ANY(${categoriesFilterString})`;
              categoryFilter.categoryFilterActive.push(categoryName);
            } else {
              categoryFilter.categoryFilterString = `categories: ANY("${categoryName}")`;
              categoryFilter.categoryFilterActive.push(categoryName);
            }
          }
          sessionStorage.setItem("categoryFilter", JSON.stringify(categoryFilter));
        }
      });
      if (!parentCategoryBlock) {
        this.appendChild(categoryBlock);
      }
    });
  }
  parseCategoryData(categoryData) {
    const arrayFilteredCategories = [];
    categoryData.data.forEach((category, index) => {
      var _a;
      if (category.value.indexOf(">") == -1) {
        arrayFilteredCategories.push({ categoryName: category.value });
        return;
      }
      if (category.value.split(">")[0] == ((_a = categoryData.data[index + 1]) == null ? void 0 : _a.value.split(">")[0])) {
        return;
      }
      const filteredCategories = categoryData.data.filter(
        (el) => el.value.split(">")[0] == category.value.split(">")[0]
      );
      const categoryName = filteredCategories[0].value.split(">")[0].trim();
      const subCategoryArray = filteredCategories.map((el) => {
        if (el.value.split(">").length > 2) {
          return;
        }
        if (!el.value.split(">")[1]) {
          return;
        }
        return {
          subCategoryName: el.value.split(">")[1].trim()
        };
      });
      arrayFilteredCategories.push({
        categoryName,
        subCategoryArray
      });
    });
    return arrayFilteredCategories;
  }
}
class SearchInFilterBlock extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.input = this.querySelector("input");
    this.clearText = this.querySelector(".jc-clear-text-icon");
    this.clearText.addEventListener("click", () => {
      this.input.value = "";
      this.input.dispatchEvent(new Event("input"));
    });
    this.input.addEventListener("input", () => {
      if (this.input.value.trim()) {
        this.classList.add("jc-clear-text");
      } else {
        this.classList.remove("jc-clear-text");
      }
      this.filter = this.input.value.toUpperCase();
      this.list = "";
      if (!this.closest("filter-block").querySelector("filter-category-item")) {
        this.list = this.closest("filter-block").querySelectorAll("filter-item");
      } else {
        this.list = this.closest("filter-block").querySelectorAll(".js-filter-category");
      }
      this.list.forEach((li) => {
        let a = li.getElementsByTagName("label")[0] || li;
        let txtValue = a.textContent || a.innerText;
        if (txtValue.toUpperCase().indexOf(this.filter) > -1) {
          li.classList.remove("jc-hidden");
        } else {
          li.classList.add("jc-hidden");
        }
      });
      const resultSearchEmpty = Array.from(this.list).every((li) => li.classList.contains("jc-hidden"));
      this.closest("filter-block").querySelectorAll("[data-parent-category]").forEach((el) => {
        if (el.querySelectorAll("li").length == el.querySelectorAll("li.jc-hidden").length) {
          el.classList.add("jc-hidden");
        } else {
          el.classList.remove("jc-hidden");
        }
      });
      if (resultSearchEmpty) {
        this.updateEmptyFilterInfo.bind(this)();
      }
    });
  }
  async updateEmptyFilterInfo() {
    const url = window.Shopify.routes.root + "apps/search";
    let filterQuery = this.input.value;
    let searchStringUpperCase = this.input.value.toUpperCase();
    if (this.closest("filter-block").id === "attributes.language") {
      for (const [key, value] of Object.entries(languageAssosiation)) {
        if (value.toUpperCase().indexOf(searchStringUpperCase) > -1) {
          filterQuery = key;
          searchStringUpperCase = key.toUpperCase();
        }
      }
    }
    const query = {
      query: filterQuery,
      rout: "search",
      visitorId: localStorage.getItem("visitorId"),
      branchSearch: "0",
      userId: window.userId
    };
    const seriesFilterString = getSeriesFilterString();
    const categoryFilter = getcategoryFilter();
    getFilterParse(
      query,
      categoryFilter,
      seriesFilterString
    );
    query.facetKeysSearch = [
      { facetKey: { key: facetToRender.find((facet) => this.closest("filter-block").id === facet.facet_key).facet_key, returnMinMax: true }, limit: 300 }
    ];
    options.body = JSON.stringify(query);
    try {
      const response = await fetch(url, options);
      let data = response;
      if (data.ok) {
        data = await data.json();
      } else {
        data = await data.text();
      }
      const dataResultsProduct = data.results;
      if (dataResultsProduct) {
        const mainFilters = data.facets;
        const filterBlock = this.closest("filter-block");
        const filterBlockId = filterBlock.id;
        const notListedFilter = mainFilters.find((filter) => filter.key === filterBlockId);
        if (filterBlockId != "categories") {
          notListedFilter.values.forEach((filter) => {
            let existedFilter = "";
            if (filter.value.indexOf('"') > -1) {
              existedFilter = filterBlock.querySelector(`[id='filter\\.p\\.${filterBlockId}-${filter.value}']`);
            } else if (filter.value.indexOf("'") > -1) {
              existedFilter = filterBlock.querySelector(`[id="filter\\.p\\.${filterBlockId}-${filter.value}"]`);
            } else {
              existedFilter = filterBlock.querySelector(`[id='filter\\.p\\.${filterBlockId}-${filter.value}']`);
            }
            if (filter.value.toUpperCase().indexOf(searchStringUpperCase) > -1 && !existedFilter) {
              const filterItem = document.createElement("filter-item");
              filterItem.className = "collection__filter-checkbox";
              filterItem.filters = {
                checked: "",
                type: this.closest("filter-block").id,
                value: filter.value
              };
              this.closest("filter-block").querySelector(".collection__filter-checkbox-list").appendChild(filterItem);
            }
          });
        } else {
          const filterItem = document.querySelector("filter-category-item");
          filterItem.filters = {
            title: "Categories",
            type: "categories",
            data: notListedFilter.values
          };
        }
      }
    } catch (error) {
      console.error(error);
    }
  }
}
__publicField(SearchInFilterBlock, "observedAttributes", ["color", "size"]);
class PriceMinimum extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.addEventListener("click", this.setPriceMinimum);
  }
  disconnectedCallback() {
    this.removeEventListener("click", this.setPriceMinimum);
  }
  setPriceMinimum() {
    const priceRange = this.closest("filter-price-item");
    const priceMax = +this.dataset.max;
    const priceMin = 0;
    const maxValuePrice = +priceRange.querySelector(".range-max").max;
    const rangeMax = priceMax / maxValuePrice * 100 + "%";
    priceRange.querySelector(".price-range__range-group").setAttribute("style", `--range-min: 0%;--range-max:${rangeMax}`);
    priceRange.querySelector(".range-min").value = priceMin;
    priceRange.querySelector(".range-max").value = priceMax;
    priceRange.querySelector("[name='filter.v.price.gte']").value = priceMin;
    priceRange.querySelector("[name='filter.v.price.lte']").value = priceMax;
    const filterJson = sessionStorage.getItem("defaultFilters") ? JSON.parse(sessionStorage.getItem("defaultFilters")) : { filterPrice: {}, queryString: [], filterCheckedItems: [] };
    filterJson.queryString = filterJson.queryString.filter(
      (string) => string.includes("price") != true
    );
    filterJson.queryString.push(`(price: IN(${priceMin}i, ${priceMax}e))`);
    filterJson.filterPrice.min = `${priceMin}`;
    filterJson.filterPrice.max = `${priceMax}`;
    if (!this.previousElementSibling) {
      this.nextElementSibling.querySelector("div").classList.add("!jc-bg-gray-300", "jc-border-gray-300");
      this.querySelector("div").classList.remove("!jc-bg-gray-300", "jc-border-gray-300");
      this.nextElementSibling.nextElementSibling.querySelector("div").classList.add("!jc-bg-gray-300", "jc-border-gray-300");
    } else if (this.previousElementSibling && this.nextElementSibling) {
      this.previousElementSibling.querySelector("div").classList.remove("!jc-bg-gray-300", "jc-border-gray-300");
      this.querySelector("div").classList.remove("!jc-bg-gray-300", "jc-border-gray-300");
      this.nextElementSibling.querySelector("div").classList.add("!jc-bg-gray-300", "jc-border-gray-300");
    } else if (!this.nextElementSibling) {
      this.previousElementSibling.querySelector("div").classList.remove("!jc-bg-gray-300", "jc-border-gray-300");
      this.querySelector("div").classList.remove("!jc-bg-gray-300", "jc-border-gray-300");
      this.previousElementSibling.previousElementSibling.querySelector("div").classList.remove("!jc-bg-gray-300", "jc-border-gray-300");
    }
    sessionStorage.setItem("defaultFilters", JSON.stringify(filterJson));
  }
}
class ActiveFilterItem extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    if (this.dataset.action == "clear-filter-price") {
      this.addEventListener("click", this.removePrice);
    } else if (this.dataset.action == "clear-filter-category") {
      this.addEventListener("click", this.removeCategoryFilter);
    } else if (this.dataset.action == "clear-filter-series") {
      this.addEventListener("click", this.removeSeriesFilter);
    }
  }
  disconnectedCallback() {
    if (this.dataset.action == "clear-filter-price") {
      this.removeEventListener("click", this.removePrice);
    } else if (this.dataset.action == "clear-filter-category") {
      this.addEventListener("click", this.removeCategoryFilter);
    } else if (this.dataset.action == "clear-filter-series") {
      this.addEventListener("click", this.removeSeriesFilter);
    }
  }
  removeSeriesFilter() {
    sessionStorage.setItem("seriesFilterString", "");
  }
  removeCategoryFilter() {
    sessionStorage.setItem("categoryFilter", "");
  }
  removePrice() {
    pageFilterPriceClear();
  }
  activeFilter(activeFilterData) {
    this.innerHTML = document.getElementById("filter-active-button").innerHTML;
    this.querySelector("label").setAttribute("for", activeFilterData.activeFilter);
    this.querySelector("p").textContent = (() => {
      switch (activeFilterData.type) {
        case "price":
          return activeFilterData.activeFilter;
        case "filter":
          return languageAssosiation[activeFilterData.activeFilter.split(/-(.*)/s)[1]] || availabilityAssosiation[activeFilterData.activeFilter.split(/-(.*)/s)[1]] || Object.keys(dateAssosiation).find((key) => dateAssosiation[key] === activeFilterData.activeFilter.split(/-(.*)/s)[1]) || activeFilterData.activeFilter.split(/-(.*)/s)[1];
        case "category":
          return activeFilterData.activeFilter;
        case "series":
          return activeFilterData.activeFilter;
        default:
          return null;
      }
    })();
  }
}
function pageFilterPriceClear() {
  const priceRange = document.querySelector("price-range");
  priceRange.querySelector(".price-range__range-group").style.cssText = "--range-min:0%;--range-max:100%";
  priceRange.querySelector(".range-min").value = priceRange.querySelector(".range-min").min;
  priceRange.querySelector(".range-max").value = priceRange.querySelector(".range-min").max;
  priceRange.querySelector("[name='filter.v.price.gte']").value = "";
  priceRange.querySelector("[name='filter.v.price.lte']").value = "";
  const filterJson = JSON.parse(sessionStorage.getItem("defaultFilters"));
  filterJson.filterPrice = {};
  filterJson.queryString = filterJson.queryString.filter(
    (string) => string.includes("price") != true
  );
  sessionStorage.setItem("defaultFilters", JSON.stringify(filterJson));
}
customElements.define("filter-block", FilterBlock);
customElements.define("active-filter-item", ActiveFilterItem);
customElements.define("filter-item", FilterItem);
customElements.define("filter-price-item", FilterPriceItem);
customElements.define("filter-category-item", FilterCategoryItem);
customElements.define("search-filter-block", SearchInFilterBlock);
customElements.define("price-minimum", PriceMinimum);
window.addEventListener("resize", setMobileFilterClass);
window.addEventListener("DOMContentLoaded", setMobileFilterClass);
function setMobileFilterClass() {
  const mobileFilters = document.getElementById("mobile-collection-filters");
  if (!mobileFilters || mobileFilters.classList.contains("wishlist")) {
    return;
  }
}
if (performance.navigation.type != performance.navigation.TYPE_RELOAD) {
  const paramsQuery = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop)
  });
  let queryString = "";
  if (paramsQuery) {
    queryString = paramsQuery.q;
  }
  resetOldFilters();
  const firstEntryFilters = {
    filterCheckedItems: [],
    queryString: [],
    filterPrice: {}
  };
  if (!(queryString == null ? void 0 : queryString.includes("opusID")) && queryString) {
    firstEntryFilters.filterCheckedItems.push("filter.p.availability-IN_STOCK");
    firstEntryFilters.queryString.push('(availability: ANY("IN_STOCK"))');
  }
  sessionStorage.setItem("defaultFilters", JSON.stringify(firstEntryFilters));
}
let skeletonProducts;
const changeLayoutBtns = document.querySelectorAll('[data-action="change-layout"]');
document.addEventListener("search:page", (e) => {
  let newLayoutMode;
  const layoutMode = sessionStorage.getItem("newLayoutMode");
  const searchProductList = document.querySelector("[data-search-product-list]");
  if (layoutMode) {
    newLayoutMode = layoutMode;
  } else {
    newLayoutMode = "list";
  }
  searchProductList.classList.remove("js-list", "js-grid");
  searchProductList.classList.add(`js-${newLayoutMode}`);
  const skeletonProductsList = document.querySelector("[data-skeleton-products-list]");
  const skeletonProductsVertical = document.querySelector("[data-skeleton-products-vertical]");
  changeLayoutBtns.forEach((btn) => btn.setAttribute("aria-disabled", true));
  if (newLayoutMode == "list") {
    skeletonProducts = skeletonProductsList;
    skeletonProductsList.classList.remove("jc-hidden");
    skeletonProductsVertical.classList.add("jc-hidden");
  } else {
    skeletonProducts = skeletonProductsVertical;
    skeletonProductsVertical.classList.remove("jc-hidden");
    skeletonProductsList.classList.add("jc-hidden");
  }
  searchProductList.classList.add("jc-hidden");
  _loadSearchPage(e.detail);
});
document.addEventListener("search:pageUpdateLayoutMode", (e) => {
  sessionStorage.setItem("newLayoutMode", `${e.detail.layoutMode}`);
});
document.addEventListener("search:pageUpdateSorting", (e) => {
  sessionStorage.setItem("sortPageMode", `${e.detail.sortValue}`);
  sessionStorage.setItem("currentPage", "");
});
document.addEventListener("search:pageUpdateProductsPerPage", (e) => {
  sessionStorage.setItem("productsPerPage", `${e.detail.productsPerPage}`);
  sessionStorage.setItem("currentPage", "");
});
document.addEventListener("search:pageUpdatePagination", (e) => {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
  sessionStorage.setItem("currentPage", e.detail.target.dataset.page);
});
let options = {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: ""
};
const facetsPreset = [
  { facetKey: { key: "brands", returnMinMax: true }, limit: 300 },
  {
    facetKey: {
      key: "price",
      returnMinMax: true,
      intervals: [{ minimum: 0, maximum: 99999999999999 }]
    }
  },
  { facetKey: { key: "attributes.series" }, limit: 300 },
  { facetKey: { key: "categories" }, limit: 300 },
  { facetKey: { key: "attributes.format" }, limit: 300 },
  { facetKey: { key: "attributes.language" }, limit: 300 },
  { facetKey: { key: "attributes.publisher" }, limit: 300 },
  { facetKey: { key: "availability" } }
];
function getNewLayoutMode(event) {
  let newLayoutMode;
  if (sessionStorage.getItem("newLayoutMode")) {
    newLayoutMode = sessionStorage.getItem("newLayoutMode");
  } else {
    newLayoutMode = event.options.defaultLayout;
    sessionStorage.setItem("newLayoutMode", newLayoutMode);
  }
  return newLayoutMode;
}
function getDefaultProductsPerPage(query, event) {
  let defaultProductsPerPage;
  if (sessionStorage.getItem("productsPerPage")) {
    defaultProductsPerPage = sessionStorage.getItem("productsPerPage");
  } else {
    defaultProductsPerPage = event.options.defaultProductsPerPage;
    sessionStorage.setItem("productsPerPage", defaultProductsPerPage);
  }
  query.branchCountResultsSearch = defaultProductsPerPage;
  return defaultProductsPerPage;
}
function getCurrentPage(query, defaultProductsPerPage) {
  let currentPage;
  if (sessionStorage.getItem("currentPage")) {
    currentPage = sessionStorage.getItem("currentPage");
  } else {
    currentPage = 1;
    sessionStorage.setItem("currentPage", currentPage);
  }
  if (currentPage > 1) {
    query.offsetSearch = (currentPage - 1) * defaultProductsPerPage;
  }
  return currentPage;
}
function getSortPageMode(event, query) {
  let sortPageMode;
  if (sessionStorage.getItem("sortPageMode")) {
    sortPageMode = sessionStorage.getItem("sortPageMode");
  } else {
    sortPageMode = event.options.currentSortBy ? event.options.currentSortBy : "relevance";
    sessionStorage.setItem("sortPageMode", `${sortPageMode}`);
  }
  if (sortPageMode == "price-ascending") {
    query.searchOrderBy = "price";
  } else if (sortPageMode == "price-descending") {
    query.searchOrderBy = "price desc";
  }
  return sortPageMode;
}
function resetOldFilters() {
  document.dispatchEvent(
    new CustomEvent("search:resetsessionStorageVariablesFilters")
  );
}
async function getSearchResult(event, filterParse, defaultProductsPerPage, currentPage, sortPageMode, url, query, paramsQuerySearchText, searchSectionId, newLayoutMode, paramsQuery, categoryFilter, seriesFilterString, data, trackAuthorView) {
  var _a, _b, _c, _d, _e, _f;
  let searchProductVariants = [];
  const productDetails = [];
  const productsResults = data.results;
  const attributionToken = data.attributionToken;
  sessionStorage.setItem("attributionToken", `${attributionToken}`);
  const resultsProductsCount = data.totalSize || 0;
  if (productsResults) {
    productsResults.forEach((searchProduct) => {
      if (searchProduct.product.title) {
        searchProductVariants.push(searchProduct.product);
        productDetails.push({
          product: {
            id: `${searchProduct.id}`
          }
        });
      }
    });
    window.dataLayer.push({
      cloud_retail: ""
    });
    const filterActivePriceMin = (_a = filterParse == null ? void 0 : filterParse.filterPrice) == null ? void 0 : _a.min;
    const filterActivePriceMax = (_b = filterParse == null ? void 0 : filterParse.filterPrice) == null ? void 0 : _b.max;
    const countPagination = Math.ceil(
      resultsProductsCount / +defaultProductsPerPage
    );
    let pagination = document.querySelector("pagination-search");
    if (!pagination) {
      pagination = document.createElement("pagination-search");
      pagination.setAttribute("page", currentPage);
      document.querySelector("[data-pagination]").appendChild(pagination);
    }
    pagination.updatePagination(
      data.totalSize,
      parseInt(currentPage),
      defaultProductsPerPage
    );
    const promotionalCardsByIndex = {};
    document.querySelectorAll("[data-search-promotion-card-position]").forEach((card) => {
      promotionalCardsByIndex[card.dataset.searchPromotionCardPosition] = card;
    });
    const trackAuthorViewList = [];
    const productTemplateItems = searchProductVariants.map((product, index) => {
      var _a2;
      let cardTemplate = ((_a2 = promotionalCardsByIndex[index + 1]) == null ? void 0 : _a2.innerHTML) || "";
      return cardTemplate + getTemplateProductResultItem(
        product,
        productsResults[index].id,
        newLayoutMode,
        event,
        trackAuthorViewList,
        trackAuthorView
      );
    }).join("");
    if (trackAuthorView) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "view_author_ta",
        ecommerce: {
          items: trackAuthorViewList
        }
      });
    }
    const headingEl = event.element.querySelector(".js-heading");
    const booksCountEl = headingEl == null ? void 0 : headingEl.querySelector(".js-books-count");
    if (booksCountEl) {
      booksCountEl.innerHTML = data.totalSize;
      headingEl.setAttribute("aria-busy", false);
    }
    event.element.querySelector("[data-search-product-list]").innerHTML = productTemplateItems;
    event.element.querySelector("[data-search-product-list]").classList.remove("jc-hidden");
    skeletonProducts.classList.add("jc-hidden");
    event.element.querySelector(
      "[data-dsk-results-count]"
    ).innerHTML = `Affiche ${currentPage == 1 ? currentPage : (currentPage - 1) * defaultProductsPerPage + 1} - 
        ${currentPage == countPagination ? resultsProductsCount : currentPage * defaultProductsPerPage} 
        de ${resultsProductsCount} résultats`;
    if (event.element.querySelector("[data-mob-results-count]")) {
      event.element.querySelector(
        "[data-mob-results-count]"
      ).innerHTML = `${resultsProductsCount} résultats`;
    }
    event.element.querySelector(
      "[data-page-size]"
    ).innerHTML = `${defaultProductsPerPage} par page`;
    event.element.querySelector(`[data-sort]`).innerHTML = event.element.querySelector(
      `[data-value^="${sortPageMode}"]`
    ).textContent;
    event.element.querySelectorAll(`[data-value]`).forEach((element) => {
      element.classList.remove("is-selected");
    });
    event.element.querySelector(`[data-value^="${sortPageMode}"]`).classList.add("is-selected");
    event.element.querySelector(`[data-value^="${defaultProductsPerPage}"]`).classList.add("is-selected");
    let countFilters = 0;
    const customeElActiveFilters = event.element.querySelector("active-filters");
    if ((filterParse == null ? void 0 : filterParse.queryString.length) > 0) {
      const activeFilters = filterParse.filterCheckedItems;
      activeFilters.forEach((activeFilter) => {
        if (activeFilter.includes("availability")) {
          return;
        }
        let checkActiveFilter = "";
        if (activeFilter.indexOf('"') > -1) {
          checkActiveFilter = customeElActiveFilters.querySelector(
            `active-filter-item label[for='` + activeFilter + `']`
          );
        } else if (activeFilter.indexOf("'") > -1) {
          checkActiveFilter = customeElActiveFilters.querySelector(
            `active-filter-item label[for="` + activeFilter + `"]`
          );
        } else {
          checkActiveFilter = customeElActiveFilters.querySelector(
            `active-filter-item label[for='` + activeFilter + `']`
          );
        }
        if (!checkActiveFilter) {
          const activeFilterItem = document.createElement("active-filter-item");
          activeFilterItem.activeFilter({ type: "filter", activeFilter });
          customeElActiveFilters.appendChild(activeFilterItem);
        }
      });
      Array.from(
        customeElActiveFilters.querySelectorAll(`active-filter-item label`)
      ).forEach((el) => {
        if (!activeFilters.includes(el.getAttribute("for"))) {
          el.closest("active-filter-item").remove();
        }
      });
      if (filterActivePriceMin && filterActivePriceMax) {
        const activeFilterItemPrice = document.createElement("active-filter-item");
        activeFilterItemPrice.setAttribute("data-action", "clear-filter-price");
        activeFilterItemPrice.activeFilter({
          type: "price",
          activeFilter: `${filterActivePriceMin} € - ${filterActivePriceMax} €`
        });
        customeElActiveFilters.appendChild(activeFilterItemPrice);
      }
      if ((categoryFilter == null ? void 0 : categoryFilter.categoryFilterActive.length) > 0) {
        (_c = categoryFilter == null ? void 0 : categoryFilter.categoryFilterActive) == null ? void 0 : _c.forEach((categoryActiveName) => {
          const activeFilterItemCategory = document.createElement("active-filter-item");
          activeFilterItemCategory.setAttribute(
            "data-action",
            "clear-filter-category"
          );
          activeFilterItemCategory.activeFilter({
            type: "category",
            activeFilter: categoryActiveName
          });
          customeElActiveFilters.appendChild(activeFilterItemCategory);
          countFilters += 1;
        });
      }
      if ((seriesFilterString == null ? void 0 : seriesFilterString.filterCheckedItems.length) > 0) {
        (_d = seriesFilterString == null ? void 0 : seriesFilterString.filterCheckedItems) == null ? void 0 : _d.forEach((seriesActiveName) => {
          const activeFilterItemSeries = document.createElement("active-filter-item");
          activeFilterItemSeries.setAttribute(
            "data-action",
            "clear-filter-series"
          );
          activeFilterItemSeries.activeFilter({
            type: "series",
            activeFilter: seriesActiveName
          });
          customeElActiveFilters.appendChild(activeFilterItemSeries);
        });
      }
      if (filterParse.filterCheckedItems.length > 0) {
        countFilters += filterParse.filterCheckedItems.includes(
          "filter.p.availability-IN_STOCK"
        ) ? filterParse.filterCheckedItems.length - 1 : filterParse.filterCheckedItems.length;
      }
      if (filterParse.filterPrice.min && filterParse.filterPrice.max) {
        countFilters += 1;
        const priceRange = event.element.querySelectorAll("price-range");
        priceRange.forEach((range) => {
          range.querySelector(".price-range__range-group").style.cssText = `
            --range-min:${filterActivePriceMin / range.querySelector(".range-min").max * 100}%;
            --range-max:${filterActivePriceMax / range.querySelector(".range-min").max * 100}%;`;
          range.querySelector(".range-min").value = filterActivePriceMin;
          range.querySelector(".range-max").value = filterActivePriceMax;
          range.querySelector("[name='filter.v.price.gte']").value = filterActivePriceMin;
          range.querySelector("[name='filter.v.price.lte']").value = filterActivePriceMax;
        });
      }
      if (countFilters > 0) {
        (_e = event.element.querySelector(".collection__filter-icon")) == null ? void 0 : _e.classList.add("collection__filter-icon--active");
        event.element.querySelector(
          "[data-mobile-filter-count]"
        ).innerHTML = `&nbsp;(${countFilters})`;
      }
    } else {
      customeElActiveFilters.querySelectorAll("active-filter-item").forEach((el) => {
        el.remove();
      });
      event.element.querySelector("[data-mobile-filter-count]").innerHTML = "";
      (_f = event.element.querySelector(".collection__filter-icon")) == null ? void 0 : _f.classList.remove("collection__filter-icon--active");
    }
    event.element.querySelector(`.search-result`).classList.remove("jc-hidden");
    event.element.querySelector(`.empty-search-result`).classList.add("jc-hidden");
  }
  const ga_search = {
    event: "ga_search",
    cloud_retail: {
      eventType: "search",
      visitorId: localStorage.getItem("visitorId"),
      orderBy: `${(query == null ? void 0 : query.searchOrderBy) ?? ""}`,
      offset: +(query == null ? void 0 : query.offsetSearch) || 0,
      searchQuery: `${paramsQuerySearchText}`,
      filter: `${(filterParse == null ? void 0 : filterParse.queryString.join(" AND ")) ?? ""}`,
      productDetails,
      attributionToken: sessionStorage.getItem("attributionToken") || null,
      userInfo: {
        userId: `${window.userId}`
      }
    },
    result_count: resultsProductsCount
  };
  window.dataLayer.push(ga_search);
}
function setAutocompleteFilter(paramsQuery, redirectKey) {
  const paramsQuerySearchText = paramsQuery.q;
  const findCurrentAutocompleteType = facetToRender.find(
    (facet) => facet.autocomplete_key == redirectKey
  );
  if (redirectKey === "category") {
    const categoryFilter = {
      categoryFilterString: "",
      categoryFilterActive: []
    };
    categoryFilter.categoryFilterString = `categories: ANY("${paramsQuerySearchText}")`;
    categoryFilter.categoryFilterActive.push(paramsQuerySearchText);
    sessionStorage.setItem("categoryFilter", JSON.stringify(categoryFilter));
  } else if (redirectKey === "series") {
    const sagaFilterString = `(attributes.series: ANY("${paramsQuerySearchText}"))`;
    const seriesObj = {
      queryString: "",
      filterCheckedItems: []
    };
    seriesObj.queryString = sagaFilterString;
    seriesObj.filterCheckedItems.push(paramsQuerySearchText);
    sessionStorage.setItem("seriesFilterString", JSON.stringify(seriesObj));
  } else if (findCurrentAutocompleteType) {
    const filterParse = {
      filterCheckedItems: [],
      queryString: [],
      filterPrice: {}
    };
    filterParse.filterCheckedItems.push(
      `filter.p.${findCurrentAutocompleteType.facet_key}-${paramsQuerySearchText}`
    );
    filterParse.filterCheckedItems.push("filter.p.availability-IN_STOCK");
    filterParse.queryString.push(
      `(${findCurrentAutocompleteType.facet_key}: ANY("${paramsQuerySearchText}"))`
    );
    filterParse.queryString.push('(availability: ANY("IN_STOCK"))');
    sessionStorage.setItem("defaultFilters", JSON.stringify(filterParse));
  }
  sessionStorage.removeItem("redirectKey");
}
async function _loadSearchPage(detail) {
  const event = detail.event;
  const searchSectionId = event.element.dataset.sectionId;
  const redirectKey = sessionStorage.getItem("redirectKey") || null;
  let trackAuthorView = false;
  const urlParams = new URLSearchParams(document.location.search);
  if (urlParams.get("author-page") === "true") {
    trackAuthorView = true;
  }
  const newLayoutMode = getNewLayoutMode(event);
  const paramsQuery = window.location.href.includes("favourite_product") ? { q: event.element.dataset.favouriteProductIds } : new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop)
  });
  const paramsQuerySearchText = window.location.href.includes(
    "favourite_product"
  ) ? event.element.dataset.favouriteProductIds : paramsQuery.q.includes("opusID") ? paramsQuery.q.split(":")[1] : paramsQuery.q;
  setAutocompleteFilter(paramsQuery, redirectKey);
  const seriesFilterString = getSeriesFilterString();
  const categoryFilter = getcategoryFilter();
  const query = {
    query: paramsQuerySearchText,
    rout: "search",
    visitorId: localStorage.getItem("visitorId"),
    branchSearch: "0",
    userId: window.userId
  };
  const filterParse = getFilterParse(
    query,
    categoryFilter,
    seriesFilterString,
    paramsQuery
  );
  const defaultProductsPerPage = getDefaultProductsPerPage(query, event);
  const currentPage = getCurrentPage(query, defaultProductsPerPage);
  const sortPageMode = getSortPageMode(event, query);
  const url = window.Shopify.routes.root + "apps/search";
  query.facetKeysSearch = facetsPreset;
  options.body = JSON.stringify(query);
  try {
    const response = await fetch(url, options);
    let data = response;
    if (data.ok) {
      data = await data.json();
    } else {
      data = await data.text();
    }
    if (!document.querySelector("#filter-p-availability")) {
      const activeFiltersItems = (filterParse == null ? void 0 : filterParse.filterCheckedItems) ?? [];
      for (const facet in facetToRender) {
        if (facetToRender[facet].facet_key == "availability") {
          const filterBlock = document.createElement("filter-block");
          filterBlock.setParentBlockFilterText = {
            title: facetToRender[facet].facet_title,
            type: facetToRender[facet].facet_key,
            showSearch: facetToRender[facet].show_search
          };
          filterBlock.setChildItemFilterAvailability = {
            title: facetToRender[facet].facet_title,
            data: [{ value: "IN_STOCK" }],
            type: facetToRender[facet].facet_key,
            checkedItems: activeFiltersItems
          };
          filterBlock.setAttribute("id", facetToRender[facet].facet_key);
          document.querySelector("active-filters").after(filterBlock);
        }
      }
    }
    if (data.results) {
      await getFilters(
        event,
        url,
        filterParse,
        paramsQuery,
        paramsQuerySearchText,
        data
      );
      getSearchResult(
        event,
        filterParse,
        defaultProductsPerPage,
        currentPage,
        sortPageMode,
        url,
        query,
        paramsQuerySearchText,
        searchSectionId,
        newLayoutMode,
        paramsQuery,
        categoryFilter,
        seriesFilterString,
        data,
        trackAuthorView
      );
      updateFilters(url, filterParse, query, data);
    } else {
      fetchData(url, options, event, paramsQuery, filterParse, query);
      const ga_search = {
        event: "ga_search",
        cloud_retail: {
          eventType: "search",
          visitorId: localStorage.getItem("visitorId"),
          orderBy: `${(query == null ? void 0 : query.searchOrderBy) ?? ""}`,
          offset: +(query == null ? void 0 : query.offsetSearch) || 0,
          searchQuery: `${paramsQuerySearchText}`,
          filter: `${(filterParse == null ? void 0 : filterParse.queryString.join(" AND ")) ?? ""}`,
          productDetails: [],
          attributionToken: sessionStorage.getItem("attributionToken") || null,
          userInfo: {
            userId: `${window.userId}`
          }
        },
        result_count: 0
      };
      window.dataLayer.push(ga_search);
    }
  } catch (error) {
    console.error(error);
    event.element.querySelector(`.search-result`).classList.add("jc-hidden");
    event.element.querySelector(`.jc-main-search-container .layout__section--secondary`).classList.add("jc-hidden");
    event.element.querySelector(`.empty-search-result`).classList.remove("jc-hidden");
    event.element.querySelector(
      `.empty-search-result .empty-state__description span`
    ).innerHTML = paramsQuery.q.trim();
  }
  changeLayoutBtns.forEach((btn) => btn.setAttribute("aria-disabled", false));
  if (!document.querySelector("[data-skeleton-filters]").classList.contains("jc-hidden")) {
    document.querySelector("[data-skeleton-filters]").classList.add("jc-hidden");
  }
}
async function fetchData(url, options2, event, paramsQuery, filterParse, query) {
  try {
    filterParse.queryString = filterParse.queryString.filter(
      (item) => !item.includes("IN_STOCK")
    );
    query.filterSearch = filterParse.queryString.join(" AND ");
    options2.body = JSON.stringify(query);
    const response = await fetch(url, options2);
    const data = response.ok ? await response.json() : await response.text();
    handleSearchResult(event, data, paramsQuery);
    if (data.results) {
      await fetchRecommendations(data.results[0].id, event);
    } else {
      await processRecommendations({ result: [] }, event);
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    handleEmptySearchResult(event, paramsQuery.q.trim());
  }
}
function handleSearchResult(event, data, paramsQuery) {
  const {
    cardElement,
    secondarySection,
    inStockEmptyResult,
    emptyResult,
    recommendation
  } = getDomElements(event);
  document.querySelector('[data-section-type="collection"]').style.backgroundColor = "#FCFCFD";
  if (data.results) {
    hideElements([cardElement, secondarySection]);
    showElement(inStockEmptyResult);
    showElement(recommendation);
    inStockEmptyResult.querySelector(
      ".empty-state__description span"
    ).textContent = paramsQuery.q.trim();
  } else {
    hideElements([cardElement, secondarySection]);
    showElement(emptyResult);
    showElement(recommendation);
    emptyResult.querySelector(".empty-state__description span").textContent = paramsQuery.q.trim();
  }
}
function handleEmptySearchResult(event, queryText) {
  const { cardElement, secondarySection, emptyResult } = getDomElements(event);
  hideElements([cardElement, secondarySection]);
  showElement(emptyResult);
  emptyResult.querySelector(".empty-state__description span").textContent = queryText;
}
async function fetchRecommendations(productId, event) {
  try {
    const result = await fetchRetailRecommendations({
      type: "no_stock",
      products: [{ primaryProductId: productId }],
      pageSize: 20
    });
    await processRecommendations(result, event);
  } catch (error) {
    console.error("Error fetching recommendations:", error);
  }
}
async function processRecommendations(result, event) {
  const ajaxRecommendationSection = document.querySelector(
    "[data-recommendation] g-carousel"
  );
  if (!ajaxRecommendationSection)
    return;
  const sectionId = ajaxRecommendationSection.dataset.sectionId;
  const productHandles = result.result.map((product) => product == null ? void 0 : product.isbn).join(",");
  const recommendationUrl = `/search/?sections=${sectionId}${productHandles ? `&product_ids=${productHandles}` : ""}`;
  try {
    const response = await fetch(recommendationUrl);
    const res = await response.json();
    const keys = Object.keys(res);
    if (keys.length > 0) {
      const recommendationTemplateText = res[keys[0]];
      const recommendationTemplate = new DOMParser().parseFromString(recommendationTemplateText, "text/html").querySelector("[data-recommendation] .splide__list").innerHTML;
      ajaxRecommendationSection.splideList.innerHTML = recommendationTemplate;
      ajaxRecommendationSection.refresh();
    }
  } catch (error) {
    console.error("Error processing recommendations:", error);
  }
}
function getDomElements(event) {
  return {
    cardElement: event.element.querySelector(
      ".search-result"
    ),
    secondarySection: event.element.querySelector(
      ".jc-main-search-container .layout__section--secondary"
    ),
    inStockEmptyResult: event.element.querySelector(
      ".empty-search-result-in-stock"
    ),
    emptyResult: event.element.querySelector(".empty-search-result"),
    recommendation: document.querySelector("[data-recommendation]")
  };
}
function hideElements(elements) {
  elements.forEach((element) => element.classList.add("jc-hidden"));
}
function showElement(element) {
  if (element) {
    element.classList.remove("jc-hidden");
  }
}
function formatDate(date) {
  const day = date.getDate();
  const monthIndex = date.getMonth();
  const year = date.getFullYear();
  const months = [
    "Janvier",
    "Février",
    "Mars",
    "Avril",
    "Mai",
    "Juin",
    "Juillet",
    "Août",
    "Septembre",
    "Octobre",
    "Novembre",
    "Décembre"
  ];
  const monthName = months[monthIndex];
  const paddedDay = day.toString().padStart(2, "0");
  return `${paddedDay} ${monthName} ${year}`;
}
const favouriteProductBtnTemplate = document.querySelector("#favourite-product-btn-template").innerHTML;
const productItemTemplate = document.querySelector("#product-item-template").innerHTML;
function getTemplateProductResultItem(product, barcode, newLayoutMode, event, trackAuthorViewList, trackAuthorView) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t;
  const getSortedVariants = (variants) => variants.edges.sort(
    (prev, next) => Number.parseFloat(prev.node.price) - Number.parseFloat(next.node.price)
  );
  let firstAvailableVariant = "";
  let [L1_main_category, L2_main_category, pricing_group, pricing_stage] = [null, null, null, null];
  if (product.shopifyRespone) {
    const sortedVariants = getSortedVariants(product.shopifyRespone.variants);
    firstAvailableVariant = ((_a = sortedVariants.find((variant) => variant.node.availableForSale)) == null ? void 0 : _a.node) || ((_b = sortedVariants.find((variant) => !variant.node.availableForSale)) == null ? void 0 : _b.node) || "";
    L1_main_category = (_c = product.shopifyRespone.L1_main_category) == null ? void 0 : _c.value;
    L2_main_category = (_d = product.shopifyRespone.L2_main_category) == null ? void 0 : _d.value;
    pricing_group = (_e = product.shopifyRespone.pricing_group) == null ? void 0 : _e.value;
    pricing_stage = (_f = product.shopifyRespone.pricing_stage) == null ? void 0 : _f.value;
  }
  const collection = (_h = (_g = product == null ? void 0 : product.shopifyRespone.collections) == null ? void 0 : _g.edges[0]) == null ? void 0 : _h.node;
  const collectionId = collection == null ? void 0 : collection.id.split("/").pop();
  const productShopifyId = product.attributes.shopifyProductId ? +product.attributes.shopifyProductId.text[0].split("/").pop() : "";
  const favouriteProducts = window.favouriteProducts || null;
  const checkFavouriteProduct = favouriteProducts == null ? void 0 : favouriteProducts.includes(productShopifyId);
  const productURL = product.uri;
  const imgSrc = ((_j = (_i = product == null ? void 0 : product.images) == null ? void 0 : _i[0]) == null ? void 0 : _j.uri) || "";
  let hideImage = imgSrc ? false : true;
  const title = product.title;
  const author = (_l = (_k = product.attributes) == null ? void 0 : _k.author) == null ? void 0 : _l.text[0];
  const price = (firstAvailableVariant == null ? void 0 : firstAvailableVariant.price) ?? product.priceInfo.price;
  const compareAtPrice = (firstAvailableVariant == null ? void 0 : firstAvailableVariant.compareAtPrice) ?? product.priceInfo.originalPrice;
  const available = (firstAvailableVariant == null ? void 0 : firstAvailableVariant.availableForSale) ?? false;
  const mainSearch = ((_m = event.options) == null ? void 0 : _m.mainSearch) ? true : false;
  const firstAvailableVariantID = (firstAvailableVariant == null ? void 0 : firstAvailableVariant.id.split("/").pop()) ?? "";
  const format = (_o = (_n = product.attributes.format) == null ? void 0 : _n.text) == null ? void 0 : _o[0];
  const publisher = (_q = (_p = product.attributes.publisher) == null ? void 0 : _p.text) == null ? void 0 : _q[0];
  const publicationDate = ((_r = product.attributes.publicationDate) == null ? void 0 : _r.text) ? new Date((_s = product.attributes.publicationDate) == null ? void 0 : _s.text) : "";
  const publicationDateStr = publicationDate ? formatDate(publicationDate) : "";
  if (trackAuthorView) {
    trackAuthorViewList.push({
      item_id: productShopifyId,
      item_variant: firstAvailableVariant == null ? void 0 : firstAvailableVariant.title,
      item_variant_id: firstAvailableVariantID,
      item_variant_title: firstAvailableVariant == null ? void 0 : firstAvailableVariant.title,
      item_product_id: productShopifyId,
      item_product_title: title,
      item_name: title,
      discount: compareAtPrice ? Number((compareAtPrice - price).toFixed(2)) : 0,
      price: +price,
      item_brand: author,
      item_category: "",
      item_list_id: collectionId || null,
      item_list_name: (collection == null ? void 0 : collection.title) || null,
      sku: firstAvailableVariant == null ? void 0 : firstAvailableVariant.sku
    });
  }
  const favouriteProductEl = favouriteProductBtnTemplate.replaceAll("[[productShopifyId]]", productShopifyId).replaceAll("[[favouriteProductBtnClass]]", checkFavouriteProduct ? "jc-fill-electricViolet jc-text-electricViolet" : "").replaceAll("[[item_id]]", firstAvailableVariantID).replaceAll("[[item_variant]]", (firstAvailableVariant == null ? void 0 : firstAvailableVariant.title) ?? "").replaceAll("[[item_variant_id]]", firstAvailableVariantID).replaceAll("[[item_variant_title]]", (firstAvailableVariant == null ? void 0 : firstAvailableVariant.title) ?? "").replaceAll("[[item_product_id]]", productShopifyId).replaceAll("[[item_product_title]]", title).replaceAll("[[item_name]]", title).replaceAll("[[discount]]", compareAtPrice ? Number((compareAtPrice - price).toFixed(2)) : 0).replaceAll("[[price]]", price).replaceAll("[[item_brand]]", author).replaceAll("[[item_list_id]]", collectionId || null).replaceAll("[[item_list_name]]", (collection == null ? void 0 : collection.title) ? `"${collection == null ? void 0 : collection.title}"` : null);
  const layoutMode = newLayoutMode == "list" ? "horizontal" : "vertical";
  const infoEl = [format, publisher, publicationDateStr].filter(Boolean).map((info) => `<span>${info}</span>`).join("<span class='jc-leading-4'>-</span>");
  const variantsJson = {
    variants: ((_t = product.shopifyRespone) == null ? void 0 : _t.variants.edges.map((item) => item.node.id.split("/").pop())) || []
  };
  const productItemEl = productItemTemplate.replaceAll("[[!available]]", !available).replaceAll("[[variantsJson]]", JSON.stringify(variantsJson).replace(/"/g, "&quot;")).replaceAll("[[layoutMode]]", layoutMode).replaceAll("[[firstAvailableVariantID]]", firstAvailableVariantID).replaceAll("[[favouriteProductEl]]", favouriteProductEl).replaceAll("[[productURL]]", productURL).replaceAll("[[imgSrc]]", imgSrc).replaceAll("[[title]]", title).replaceAll("[[hideImage]]", hideImage).replaceAll("[[!hideImage]]", !hideImage).replaceAll("[[author]]", author).replaceAll("[[infoEl]]", infoEl).replaceAll("[[price]]", price ? window.jollyFunctions.formatMoney(price) : "").replaceAll("[[compareAtPrice]]", compareAtPrice ? window.jollyFunctions.formatMoney(compareAtPrice) : "").replaceAll("[[hideCompareAtPrice]]", compareAtPrice <= price).replaceAll("[[hideSecondaryAtcButton]]", mainSearch).replaceAll("[[L1_main_category]]", L1_main_category ? `&quot;${L1_main_category}&quot;` : null).replaceAll("[[L2_main_category]]", L2_main_category ? `&quot;${L2_main_category}&quot;` : null).replaceAll("[[pricing_group]]", pricing_group ? `&quot;${pricing_group}&quot;` : null).replaceAll("[[pricing_stage]]", pricing_stage ? `&quot;${pricing_stage}&quot;` : null).replaceAll("[[productShopifyId]]", productShopifyId).replaceAll("[[barcode]]", barcode || "");
  return productItemEl;
}
class SearchPagination extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.innerHTML = document.getElementById(
      "search-page-pagination"
    ).innerHTML;
  }
  updatePagination(data, currentPage, defaultProductsPerPage) {
    var _a, _b;
    this.data = data;
    this.defaultProductsPerPage = defaultProductsPerPage;
    const resultsProductsCount = data;
    const countPagination = Math.ceil(
      resultsProductsCount / +defaultProductsPerPage
    );
    const nextPageButton = this.querySelector(".pagination__next");
    const prevPageButton = this.querySelector(".pagination__prev");
    const paginationCount = this.querySelector(".js-pagination__count-page");
    const paginationCurrentPage = this.querySelector(
      ".js-pagination__current-page"
    );
    prevPageButton == null ? void 0 : prevPageButton.setAttribute("aria-disabled", currentPage == 1);
    nextPageButton == null ? void 0 : nextPageButton.setAttribute("aria-disabled", currentPage == countPagination);
    if (paginationCount) {
      paginationCount.innerHTML = countPagination;
    }
    if (paginationCurrentPage) {
      paginationCurrentPage.innerHTML = currentPage;
    }
    nextPageButton == null ? void 0 : nextPageButton.setAttribute("data-page", currentPage + 1);
    prevPageButton == null ? void 0 : prevPageButton.setAttribute("data-page", currentPage - 1);
    if (countPagination == 1) {
      (_a = this.closest("[data-pagination]")) == null ? void 0 : _a.classList.add("jc-hidden");
    } else {
      (_b = this.closest("[data-pagination]")) == null ? void 0 : _b.classList.remove("jc-hidden");
    }
    this.querySelectorAll("[data-pagination-item]").forEach((el, index) => {
      el.classList.remove("is-active", "jc-pointer-event-none");
      if (el.classList.contains("js-first-page")) {
        el.innerHTML = 1;
        el.setAttribute("data-page", 1);
      } else if (el.classList.contains("js-last-page")) {
        el.innerHTML = countPagination;
        el.setAttribute("data-page", countPagination);
      } else {
        let pageShift = currentPage - 3;
        el.innerHTML = pageShift + index;
        el.setAttribute("data-page", pageShift + index);
        el.classList.remove("jc-hidden");
        if (pageShift + index < 2 || pageShift + index > countPagination - 1) {
          el.classList.add("jc-hidden");
        }
        if (pageShift <= 1) {
          this.querySelector(".js-first-spacing").classList.add("jc-hidden");
        } else {
          this.querySelector(".js-first-spacing").classList.remove("jc-hidden");
        }
        if (pageShift + 6 >= countPagination) {
          this.querySelector(".js-last-spacing").classList.add("jc-hidden");
        } else {
          this.querySelector(".js-last-spacing").classList.remove("jc-hidden");
        }
      }
    });
    this.querySelectorAll(
      `[data-page='${currentPage}']:not(.jc-hidden)`
    ).forEach((el) => {
      el.classList.add("is-active", "jc-pointer-event-none");
    });
  }
  attributeChangedCallback(name, oldValue, newValue) {
    this.updatePagination(this.data, newValue, this.defaultProductsPerPage);
  }
}
__publicField(SearchPagination, "observedAttributes", ["page"]);
customElements.define("pagination-search", SearchPagination);
//# sourceMappingURL=jc-bundle-search.js.map
